import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

const sections = [
  {
    title: "What cookies and local storage are",
    text:
      "Cookies are small text files stored by a browser. Local storage is a similar browser feature that keeps information on your device. Pawluna currently uses local storage to keep your shopping cart available between visits.",
  },
  {
    title: "Strictly necessary technologies",
    text:
      "These technologies support functions you request, such as remembering cart contents and maintaining site security. Because they are needed to provide the requested service, they cannot always be disabled through our site controls.",
  },
  {
    title: "Preferences",
    text:
      "Preference technologies may remember choices such as language, region, or display settings. If introduced, they will be used only to make the site work in the way you have selected.",
  },
  {
    title: "Analytics and marketing",
    text:
      "We do not currently set our own analytics or advertising cookies. If we add optional analytics or marketing technologies, this policy will be updated and consent choices will be provided where required.",
  },
  {
    title: "Third-party services",
    text:
      "Some site resources, such as hosted fonts or payment services, may be supplied by third parties. Those providers may process technical information under their own policies when your browser connects to them.",
  },
  {
    title: "Managing your choices",
    text:
      "You can block or delete cookies and clear local storage through your browser settings. Doing so may remove your saved cart or prevent parts of the site from working as expected.",
  },
  {
    title: "Updates and contact",
    text:
      "This policy is effective October 16, 2026. We may update it when our technology or legal obligations change. Questions can be sent to many@pawluna.art or Pawluna, 60 Harris Rd, Mineral Bluff, GA 30559 US.",
  },
];

function CookiePolicy() {
  return (
    <div className="privacy">
      <Header />
      <div className="main-content full-width inner-page">
        <div className="background-content" />
        <div className="background">
          <div className="shadow" />
          <div className="pattern">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-12 center-column content-with-background" id="content">
                      <div style={{ paddingBottom: 10 }}>
                        <div className="pdh-page pdh-policy-page">
                          <section className="pdh-section pdh-container">
                            <h1 className="pdh-policy-title">Cookie Policy</h1>
                            <div className="pdh-policy-layout">
                              <div className="pdh-policy-main">
                                <div className="pdh-policy-intro-box">
                                  <p>
                                    This policy explains how Pawluna uses cookies,
                                    local storage, and similar browser technologies.
                                  </p>
                                </div>
                                <div className="pdh-policy-sections">
                                  {sections.map((section, index) => (
                                    <div className="pdh-policy-section" key={section.title}>
                                      <ol start={index + 1}>
                                        <li className="pdh-policy-section-title">
                                          {section.title}
                                        </li>
                                      </ol>
                                      <div className="pdh-policy-section-content">
                                        <p className="pdh-policy-text">{section.text}</p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
